import { render, staticRenderFns } from "./cargoWarehousingDetail.vue?vue&type=template&id=68783aa2&scoped=true"
import script from "./cargoWarehousingDetail.vue?vue&type=script&lang=js"
export * from "./cargoWarehousingDetail.vue?vue&type=script&lang=js"
import style0 from "./cargoWarehousingDetail.vue?vue&type=style&index=0&id=68783aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68783aa2",
  null
  
)

export default component.exports